export default "__VITE_ASSET__DfWGiCy4__"